<script>
import FileDropzone from '../../components/util/FileDropzone.vue';
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import pdfWorker from 'pdfjs-dist/build/pdf.worker.entry';

// pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;
export default {
    components: {
        FileDropzone,
    },
    data() {
        return {
            archivos: [],
            tipos_validos: ['.pdf'],
            textoExtraido: '',
            datosFactura: {
                tipo: '',
                numero: '',
                fecha: ''
            }
        };
    },
    watch: {
        archivos() {
            this.procesarArchivo();
        }
    },
    methods: {
        async procesarArchivo() {
            if (this.archivos.length === 0) {
                this.textoExtraido = '';
                this.datosFactura = { tipo: '', numero: '', fecha: '' };
                return;
            }
            const primerArchivo = this.archivos[0];
            const texto = await this.extraerTextoDePDF(primerArchivo);
            this.textoExtraido = texto;
            this.extraerDatosFactura(texto);
        },
        async extraerTextoDePDF(file) {
            try {
                const arrayBuffer = await file.arrayBuffer();
                const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

                let textoCompleto = '';
                for (let i = 1; i <= pdf.numPages; i++) {
                    const page = await pdf.getPage(i);
                    const content = await page.getTextContent();
                    const strings = content.items.map(item => item.str).join(' ');
                    textoCompleto += strings + '\n';
                }
                return textoCompleto;
            } catch (error) {
                console.error('❌ Error al leer PDF con pdfjs-dist:', error);
                return '';
            }
        },
        extraerDatosFactura(texto) {
            const fechaMatch = texto.match(/\b(\d{2}\/\d{2}\/\d{4})\b/);
            const numeroMatch = texto.match(/(\d{4}\s*-\s*\d{8})/);
            const tipoMatch = texto.match(/\b([A-Z])\b\s+ORIGINAL/);

            this.datosFactura = {
                fecha: fechaMatch ? fechaMatch[1] : '',
                numero: numeroMatch ? numeroMatch[1] : '',
                tipo: tipoMatch ? tipoMatch[1] : ''
            };
        },
        onArchivosChange(nuevosArchivos) {
            this.archivos = nuevosArchivos;
        }
    }
};
</script>

<template>
    <div>
        <v-row class="d-flex justify-center mt-0">
            <v-col cols="12">
                <h2 class="mb-2">Seleccione los archivos a renombrar</h2>
                <!-- Escuchar evento update:files o el que emita FileDropzone -->
                <FileDropzone :files="archivos" :tipos="tipos_validos" multiple :max_size="100"
                    @update:files="onArchivosChange" />
            </v-col>
        </v-row>

        <v-row v-if="textoExtraido">
            <v-col cols="12">
                <v-card class="pa-4 mb-4">
                    <h3>Datos de la Factura</h3>
                    <p><strong>Tipo:</strong> {{ datosFactura.tipo }}</p>
                    <p><strong>Número:</strong> {{ datosFactura.numero }}</p>
                    <p><strong>Fecha:</strong> {{ datosFactura.fecha }}</p>
                </v-card>
                <v-card class="pa-4">
                    <h3 class="mb-2">Texto extraído:</h3>
                    <pre style="white-space: pre-wrap;">{{ textoExtraido }}</pre>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
